<mat-form-field>
  <mat-select placeholder="Select..." (valueChange)="change()" [(ngModel)]="question.answer!.value" name="item">
    <mat-option *ngFor="let item of question.configuration.options" [value]="item.value" class="notranslate" appNoTranslate>
      {{ item.key }}
    </mat-option>
  </mat-select>
</mat-form-field>
<div class="block-message" *ngIf="blockMessage">
  <mat-icon>warning</mat-icon>
  <span>{{ blockMessage }}</span>
</div>
